export default "__VITE_ASSET__4iPtkvv7__"